import {Fragment} from "react";
import {TableCell, TableRow, useTheme} from "@mui/material";
import LocationDevideRow from "./LocationDevideRow";
import {DomainLocationStatusQuery} from "./queries.generated";

type Props = {
    location: DomainLocationStatusQuery["domainStatus"]["locations"][number];
    domainId: number;
};

export default ({location, domainId}: Props) => {
    const theme = useTheme();

    return (
        <Fragment>
            <TableRow>
                <TableCell colSpan={100} style={{backgroundColor: theme.palette.divider}}>
                    <span style={{fontWeight: "bold", marginRight: 5, fontSize: "1.2em"}}>{location.name}</span>
                    <span style={{opacity: 0.8}}>({location.description})</span>
                </TableCell>
            </TableRow>
            {location.statuses.map((dev, idx) => (
                <LocationDevideRow
                    hideNumber={dev.userId === location.statuses[idx - 1]?.userId}
                    hideNumberBottomBorder={dev.userId === location.statuses[idx + 1]?.userId}
                    key={idx}
                    domainId={domainId}
                    deviceInfo={dev}
                />
            ))}
        </Fragment>
    );
};
